"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permissions = void 0;
exports.instanceOfPermissions = instanceOfPermissions;
exports.PermissionsFromJSON = PermissionsFromJSON;
exports.PermissionsFromJSONTyped = PermissionsFromJSONTyped;
exports.PermissionsToJSON = PermissionsToJSON;
exports.PermissionsToJSONTyped = PermissionsToJSONTyped;
/**
 *
 * @export
 */
exports.Permissions = {
    AccountDelete: 'account:delete',
    AddressDistanceRead: 'address-distance:read',
    AdminChat: 'admin:chat',
    AdminLinksRead: 'admin:links:read',
    AdminProfileFastTrack: 'admin:profile:fast-track',
    AdminTestDataCreate: 'admin:test-data:create',
    AlertDismiss: 'alert:dismiss',
    AnalyticsEventCreate: 'analytics:event:create',
    AssessmentsAssign: 'assessments:assign',
    AssessmentsAssignableRead: 'assessments:assignable:read',
    AssessmentsRegulatoryAssign: 'assessments:regulatory:assign',
    AssessmentsRegulatoryRead: 'assessments:regulatory:read',
    AssessmentsReset: 'assessments:reset',
    AssessmentsSync: 'assessments:sync',
    AuditHistoryRead: 'audit:history:read',
    BackgroundCheckPackageList: 'background-check-package:list',
    BackgroundCheckApprove: 'background-check:approve',
    BackgroundCheckCancel: 'background-check:cancel',
    BackgroundCheckList: 'background-check:list',
    BackgroundCheckRead: 'background-check:read',
    BackgroundCheckSubmit: 'background-check:submit',
    BackgroundCheckSync: 'background-check:sync',
    BillingFacilityInvoice: 'billing:facility:invoice',
    BillingFacilityList: 'billing:facility:list',
    BillingFeesRead: 'billing:fees:read',
    BillingInvoiceList: 'billing:invoice:list',
    BonusCreate: 'bonus:create',
    BonusDelete: 'bonus:delete',
    BonusUpdate: 'bonus:update',
    CallLightAdmin: 'call-light:admin',
    CertificationCardUpdate: 'certification-card:update',
    CertificationDelete: 'certification:delete',
    CertificationList: 'certification:list',
    CertificationRead: 'certification:read',
    CertificationUpdate: 'certification:update',
    CertificationVerify: 'certification:verify',
    CredentialsCheckList: 'credentials-check:list',
    CredentialsCheckNotify: 'credentials-check:notify',
    CredentialsCheckValidateShifts: 'credentials-check:validate-shifts',
    DhsBackgroundCheckApprove: 'dhs-background-check:approve',
    DhsBackgroundCheckDocumentDelete: 'dhs-background-check:document:delete',
    DhsBackgroundCheckDocumentRead: 'dhs-background-check:document:read',
    DhsBackgroundCheckDocumentUpload: 'dhs-background-check:document:upload',
    DhsBackgroundCheckRead: 'dhs-background-check:read',
    DhsBackgroundCheckSubmit: 'dhs-background-check:submit',
    DocumentVerificationAudit: 'document-verification:audit',
    FacilityInterestCreate: 'facility-interest:create',
    FacilityProfileDocumentDelete: 'facility-profile-document:delete',
    FacilityProfileDocumentRead: 'facility-profile-document:read',
    FacilityProfileDocumentWrite: 'facility-profile-document:write',
    FacilityBilling: 'facility:billing',
    FacilityBlockNurseCreate: 'facility:blockNurse:create',
    FacilityBlockNurseDelete: 'facility:blockNurse:delete',
    FacilityCreate: 'facility:create',
    FacilityDeactivate: 'facility:deactivate',
    FacilityInterestedNurseDismiss: 'facility:interestedNurse:dismiss',
    FacilityInterestedNurseRestore: 'facility:interestedNurse:restore',
    FacilityList: 'facility:list',
    FacilityMemberDelete: 'facility:member:delete',
    FacilityMemberList: 'facility:member:list',
    FacilityNurseList: 'facility:nurse:list',
    FacilityNurseVerificationCreate: 'facility:nurseVerification:create',
    FacilityNurseVerificationDelete: 'facility:nurseVerification:delete',
    FacilityOrientationList: 'facility:orientation:list',
    FacilityOrientationView: 'facility:orientation:view',
    FacilityOrientationMatchesList: 'facility:orientationMatches:list',
    FacilityOrientationRequestsList: 'facility:orientationRequests:list',
    FacilityPlatformFeeUpdate: 'facility:platform-fee:update',
    FacilityReactivate: 'facility:reactivate',
    FacilitySearch: 'facility:search',
    FacilityShiftList: 'facility:shift:list',
    FacilityShiftView: 'facility:shift:view',
    FacilityShiftMatchesList: 'facility:shiftMatches:list',
    FacilityShiftRequestsList: 'facility:shiftRequests:list',
    FacilityShiftViewsList: 'facility:shiftViews:list',
    FacilityUpdate: 'facility:update',
    FacilityView: 'facility:view',
    FeatureFlagsProfileRead: 'feature-flags:profile:read',
    FeatureFlagsRead: 'feature-flags:read',
    FeatureFlagsWrite: 'feature-flags:write',
    FitTestDocumentationUpdate: 'fit-test:documentation:update',
    FitTestRead: 'fit-test:read',
    FitTestWrite: 'fit-test:write',
    GeoLatLng: 'geo:lat-lng',
    GeoZip: 'geo:zip',
    InfectiousDiseaseTestCardUpdate: 'infectious-disease-test-card:update',
    InfectiousDiseaseTestOrderFulfill: 'infectious-disease-test-order:fulfill',
    InfectiousDiseaseTestOrderRequest: 'infectious-disease-test-order:request',
    InfectiousDiseaseTestOrderView: 'infectious-disease-test-order:view',
    InfectiousDiseaseTestList: 'infectious-disease-test:list',
    InfectiousDiseaseTestRead: 'infectious-disease-test:read',
    InfectiousDiseaseTestUpdate: 'infectious-disease-test:update',
    InviteCreate: 'invite:create',
    InviteDelete: 'invite:delete',
    InviteList: 'invite:list',
    JurisdictionRead: 'jurisdiction:read',
    JurisdictionWrite: 'jurisdiction:write',
    NoteDelete: 'note:delete',
    NoteDeleteAttachment: 'note:deleteAttachment',
    NoteRead: 'note:read',
    NoteUploadAttachment: 'note:uploadAttachment',
    NoteWrite: 'note:write',
    NurseLicenseCompactRead: 'nurse-license-compact:read',
    NurseLicenseCompactWrite: 'nurse-license-compact:write',
    NurseActionsNeededCountsRead: 'nurse:actions-needed-counts:read',
    NurseContractRead: 'nurse:contract:read',
    NurseContractReset: 'nurse:contract:reset',
    NurseContractSign: 'nurse:contract:sign',
    NurseEmrRead: 'nurse:emr:read',
    NurseEmrWrite: 'nurse:emr:write',
    NurseLicenseCreate: 'nurse:license:create',
    NurseLicenseDelete: 'nurse:license:delete',
    NurseLicenseRead: 'nurse:license:read',
    NurseLicenseVerify: 'nurse:license:verify',
    NurseMissingShiftReportCreate: 'nurse:missingShiftReport:create',
    NurseOrientationList: 'nurse:orientation:list',
    NurseProfileCompletenessRead: 'nurse:profileCompleteness:read',
    NurseShiftList: 'nurse:shift:list',
    NurseStatesAuthorize: 'nurse:states:authorize',
    NurseStatesDelete: 'nurse:states:delete',
    NurseStatesRead: 'nurse:states:read',
    OrientationMatchCreate: 'orientation-match:create',
    OrientationMatchNotify: 'orientation-match:notify',
    OrientationMatchView: 'orientation-match:view',
    OrientationOpportunityArchive: 'orientation-opportunity:archive',
    OrientationOpportunityCreate: 'orientation-opportunity:create',
    OrientationOpportunityNotify: 'orientation-opportunity:notify',
    OrientationOpportunityRead: 'orientation-opportunity:read',
    OrientationOpportunityRequest: 'orientation-opportunity:request',
    OrientationOpportunityRequestDecline: 'orientation-opportunity:request:decline',
    OrientationOpportunityRequestWithdraw: 'orientation-opportunity:request:withdraw',
    OrientationOpportunitySearch: 'orientation-opportunity:search',
    OrientationOpportunityUpdate: 'orientation-opportunity:update',
    OrientationCancel: 'orientation:cancel',
    OrientationClaimsRead: 'orientation:claims:read',
    OrientationCreate: 'orientation:create',
    OrientationDocumentDelete: 'orientation:document:delete',
    OrientationDocumentWrite: 'orientation:document:write',
    OrientationNurseAccept: 'orientation:nurse:accept',
    OrientationNurseApprove: 'orientation:nurse:approve',
    OrientationNurseCancelAssignment: 'orientation:nurse:cancelAssignment',
    OrientationNurseCancelRequest: 'orientation:nurse:cancelRequest',
    OrientationNurseDismiss: 'orientation:nurse:dismiss',
    OrientationNurseReject: 'orientation:nurse:reject',
    OrientationNurseRequest: 'orientation:nurse:request',
    OrientationRead: 'orientation:read',
    OrientationRequest: 'orientation:request',
    OrientationRequestCancel: 'orientation:request:cancel',
    OrientationRequestDecline: 'orientation:request:decline',
    OrientationSearch: 'orientation:search',
    OrientationTimeWorked: 'orientation:time-worked',
    OrientationUpdate: 'orientation:update',
    PayPeriodsCreate: 'pay-periods:create',
    PayPeriodsRead: 'pay-periods:read',
    PayrollCheckRead: 'payroll:check:read',
    PayrollCheckUpdate: 'payroll:check:update',
    PermissionsRead: 'permissions:read',
    PlatformAdminList: 'platform-admin:list',
    ProfileAddressCreate: 'profile:address:create',
    ProfileAddressDelete: 'profile:address:delete',
    ProfileAddressRead: 'profile:address:read',
    ProfileAddressWrite: 'profile:address:write',
    ProfileAvatarDownload: 'profile:avatar:download',
    ProfileBasicRead: 'profile:basic:read',
    ProfileBlockCreate: 'profile:block:create',
    ProfileBlockDelete: 'profile:block:delete',
    ProfileFacilitiesRead: 'profile:facilities:read',
    ProfileList: 'profile:list',
    ProfilePayrollCreate: 'profile:payroll:create',
    ProfilePayrollRead: 'profile:payroll:read',
    ProfilePayrollReset: 'profile:payroll:reset',
    ProfilePhoneNumberCreate: 'profile:phoneNumber:create',
    ProfilePhoneNumberDelete: 'profile:phoneNumber:delete',
    ProfilePhoneNumberRead: 'profile:phoneNumber:read',
    ProfilePhoneNumberWrite: 'profile:phoneNumber:write',
    ProfilePreferenceRead: 'profile:preference:read',
    ProfilePreferenceWrite: 'profile:preference:write',
    ProfilePublicRead: 'profile:public:read',
    ProfileRead: 'profile:read',
    ProfileResumeDownload: 'profile:resume:download',
    ProfileResumeUpload: 'profile:resume:upload',
    ProfileSpecialtyRead: 'profile:specialty:read',
    ProfileSpecialtyWrite: 'profile:specialty:write',
    ProfileVerifiedFacilitiesRead: 'profile:verified-facilities:read',
    ProfileWrite: 'profile:write',
    RateCalculatorCalculate: 'rate-calculator:calculate',
    RateCalculatorOptionsRead: 'rate-calculator:options:read',
    RegulatoryAssessmentsCreate: 'regulatory-assessments:create',
    RegulatoryAssessmentsRead: 'regulatory-assessments:read',
    RegulatoryAssessmentsUpdate: 'regulatory-assessments:update',
    RolesRead: 'roles:read',
    ScheduleNurseRead: 'schedule:nurse:read',
    ScheduleNurseWrite: 'schedule:nurse:write',
    ShiftMatchCreate: 'shift-match:create',
    ShiftMatchNotify: 'shift-match:notify',
    ShiftMatchView: 'shift-match:view',
    ShiftNotificationsOrientationRead: 'shift-notifications:orientation:read',
    ShiftNotificationsShiftView: 'shift-notifications:shift:view',
    ShiftCancel: 'shift:cancel',
    ShiftClaim: 'shift:claim',
    ShiftCreate: 'shift:create',
    ShiftDelete: 'shift:delete',
    ShiftFacilityRate: 'shift:facility:rate',
    ShiftList: 'shift:list',
    ShiftNurseAccept: 'shift:nurse:accept',
    ShiftNurseApprove: 'shift:nurse:approve',
    ShiftNurseCancel: 'shift:nurse:cancel',
    ShiftNurseCancelRequest: 'shift:nurse:cancelRequest',
    ShiftNurseDismiss: 'shift:nurse:dismiss',
    ShiftNurseRate: 'shift:nurse:rate',
    ShiftNurseReject: 'shift:nurse:reject',
    ShiftNurseRequest: 'shift:nurse:request',
    ShiftProposalAccept: 'shift:proposal:accept',
    ShiftProposalCancel: 'shift:proposal:cancel',
    ShiftProposalCreate: 'shift:proposal:create',
    ShiftProposalReject: 'shift:proposal:reject',
    ShiftRequest: 'shift:request',
    ShiftRequestCancel: 'shift:request:cancel',
    ShiftRequestDecline: 'shift:request:decline',
    ShiftSearch: 'shift:search',
    ShiftTimeWorked: 'shift:time-worked',
    ShiftTimeWorkedDelete: 'shift:time-worked:delete',
    ShiftUpdate: 'shift:update',
    ShiftView: 'shift:view',
    SpecialtyList: 'specialty:list',
    SpecialtyUpdate: 'specialty:update',
    StipendCreate: 'stipend:create',
    StipendDelete: 'stipend:delete',
    TimecardReminderList: 'timecard-reminder:list',
    TimecardReminderNotify: 'timecard-reminder:notify',
    TuberculosisScreeningQuestionsRead: 'tuberculosis-screening:questions:read',
    TuberculosisScreeningRead: 'tuberculosis-screening:read',
    TuberculosisScreeningWrite: 'tuberculosis-screening:write',
    VaccinationCardUpdate: 'vaccination-card:update',
    VaccinationList: 'vaccination:list',
    VaccinationRead: 'vaccination:read',
    VaccinationUpdate: 'vaccination:update',
    WorkQualificationOrientationRead: 'work-qualification:orientation:read',
    WorkQualificationShiftRead: 'work-qualification:shift:read'
};
function instanceOfPermissions(value) {
    for (const key in exports.Permissions) {
        if (Object.prototype.hasOwnProperty.call(exports.Permissions, key)) {
            if (exports.Permissions[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function PermissionsFromJSON(json) {
    return PermissionsFromJSONTyped(json, false);
}
function PermissionsFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PermissionsToJSON(value) {
    return value;
}
function PermissionsToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=Permissions.js.map